<template>
    <layout>
        <rdkm-title>
            {{ $t('Причины отказов') }}
            <router-link tag="span" to="/reasons/add">
                <b-button class="float-right" right size="sm" variant="primary">
                    <font-awesome-icon icon="plus" /> {{ $t('Добавить') }}
                </b-button>
            </router-link>
        </rdkm-title>
        <div class="tile">            
            <rdkm-grid ref="grid" :state="query">
                <grid-column name="EDIT" cell="edit-cell"></grid-column>
                <grid-column name="name" :title="$t('Причина')"></grid-column>
                <grid-column name="type" :title="$t('Тип')"></grid-column>
                <grid-column name="isTemporary" :title="$t('Временная')"></grid-column>
                <grid-column name="DELETE" :cell="isEditAndDeleteAccessible() ? 'delete-cell' : ''"></grid-column>              
            </rdkm-grid>
        </div>
    </layout>
</template>

<script>
import Grid from "../../components/grid/Grid.vue";
import GridColumn from "../../components/grid/GridColumn.vue";
import RouteHelper from "@/helpers/route.helper";

export default {
  name: "Reasons",
  props: ["query"],
  components: {
    "rdkm-grid": Grid,
    "grid-column": GridColumn
  },
  methods: {
    isEditAndDeleteAccessible: function() {        
        return RouteHelper.isRouteNameAccessible(this.$auth.user(), 'ReasonEdit');
    }
  }
};
</script>
